import { useEffect, useState } from 'react';
import './SoltBrandingLogo.scss';

interface SoltBrandingLogoProps {
    src: string;
    alt: string;
    // shows the placeholder while the branding is still being fetched
    isLoading?: boolean;
    className?: string;
}

// A branding logo in a fixed 3:1 slot (the recommended 240×80 upload). Shows a neutral
// placeholder while loading, and also when the image URL fails to load.
const SoltBrandingLogo = ({ src, alt, isLoading = false, className = '' }: Readonly<SoltBrandingLogoProps>) => {
    const [hasError, setHasError] = useState<boolean>(false);

    // a new URL gets a fresh attempt
    useEffect(() => {
        setHasError(false);
    }, [src]);

    if (isLoading || hasError) {
        return (
            <div className={`solt-branding-logo solt-branding-logo-placeholder ${className}`} role="img" aria-label={alt}>
                <i className="ri-image-line"></i>
            </div>
        );
    }

    return <img className={`solt-branding-logo ${className}`} src={src} alt={alt} onError={() => setHasError(true)} />;
};

export default SoltBrandingLogo;
